import React from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

function Vbox({ input, hw, ht, mr }) {

  return (
    <div
      style={{
        width: hw ? "50%" : null,
        // flexShrink: 1,
        height: 400,
        // marginRight: mr ? mr : 0,
        // marginBottom: 20,
        padding: 10,
        paddingLeft: 20,
        margin: 10,
        background: "#F8F9FD",
        boxShadow: "9px 9px 10px #D1D9E6, -9px -9px 10px #FFFFFF",
        borderRadius: "20px",
      }}
    >
      {input}
    </div>
  );
}
function App() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ width: "80%" }}>
        <Vbox
          input={
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div>Profile Details</div>
              <div>Role</div>
              <div>Manager</div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <TextField
                  id="outlined-basic"
                  label="First Name"
                  variant="outlined"
                />
                <TextField
                  id="outlined-basic"
                  label="Last Name"
                  variant="outlined"
                />
              </div>
              <Button variant="contained">
                Save Changes
              </Button>
              <TextField
                id="outlined-basic"
                label="Email Address"
                variant="outlined"
                disabled={true}
                value={"test@test.com"}

              />
              <Button variant="contained">
                Reset Password
              </Button>
              <Button variant="contained" color="error">
                Delete My Profile
              </Button>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default App;
